import React from "react";
import { Book24Filled, IosChevronRightFilled } from "@fluentui/react-icons";
import { card, centered, colors, useTextStyles } from "../styles";
import { makeStyles } from "@fluentui/react-components";
import { Screen } from "../../utils/common/constants";

const useStyles = makeStyles({
  actionCard: {
    ...card,
    flexDirection: "row",
    justifyContent: "start",
    gap: "10px",
    textAlign: "center",
    cursor: "pointer"
  }
});

export const QuickActions: React.FC<{ navigate: Function }> = ({ navigate }) => {
  const styles = useStyles();
  const textStyles = useTextStyles();

  return (
    <div style={{ ...centered, gap: "24px" }}>
      <div className={styles.actionCard} onClick={() => navigate(Screen.Report)}>
        <Book24Filled color={colors.fundwave} />
        <span className={textStyles.normalText}>Save Report to Fundwave</span>
        <IosChevronRightFilled fontSize="24px" style={{ marginLeft: "auto", marginRight: "10px" }} />
      </div>

      {/* <div className={styles.actionCard} onClick={() => dispatchToast(notify("Coming soon"), { intent: "info" })}>
        <div style={{ color: colors.fundwave }}>
          <MathFormula24Filled />
        </div>
        <span className={textStyles.btnText}>Formula Builder</span>
      </div> */}
    </div>
  );
};

export default QuickActions;
